import * as React from 'react';
import clsx from 'clsx';
import { Icon, Typography, TypographyType } from '@/components/common';
import Icons from '@/const/icons';
import { ActionRequired } from '@/interfaces';
import { formatDateToShortDate } from '@/lib';
import {
	getTimerLabelText,
	isPastDue,
	shouldShowTimer,
} from '@/utils/actionRequired';

interface TimerLabelProps {
	item: ActionRequired;
	className?: string;
}

export const TimerLabel: React.FC<TimerLabelProps> = ({ item, className }) => {
	if (!shouldShowTimer(item)) return <></>;
	const isLabelRed = isPastDue(item.due_date);
	return (
		<div className={clsx('flex items-center gap-1', className)}>
			<span className="w-[14px] h-[14px]">
				<Icon
					src={Icons.timer}
					className={isLabelRed ? 'text-main-red' : 'text-main-blue-dark'}
				/>
			</span>
			<Typography
				type="regular-12"
				className={clsx(
					'xl:whitespace-nowrap line-clamp-1',
					isLabelRed ? 'text-main-red' : 'text-main-blue-dark'
				)}
			>
				{getTimerLabelText(item.due_date)}
			</Typography>
		</div>
	);
};

interface ByDateProps {
	item: ActionRequired;
	dateTypography?: TypographyType;
	className?: string;
}

export const ByDate: React.FC<ByDateProps> = ({
	item,
	dateTypography = 'regular-16',
	className,
}) => {
	if (!item.due_date) return <></>;
	return (
		<Typography
			type={dateTypography}
			className={clsx(
				'flex items-center whitespace-nowrap text-opacity-black',
				className
			)}
		>
			by {formatDateToShortDate(item.due_date)}.
		</Typography>
	);
};
